import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppDownloadComponent } from './core/components/app-download/app-download.component';
import { IconRegistryService } from './core/services/icon-registry.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppDownloadComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true
})
export class AppComponent {
  title = 'IPV';
  mobile = false;

  constructor(
    private responsive: BreakpointObserver,
    private iconRegistry: IconRegistryService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    // Initialize SVG icons
    this.iconRegistry.initializeIcons();

    // Handle responsive breakpoints
    this.responsive.observe([
      Breakpoints.Web,
      Breakpoints.TabletLandscape
    ])
      .subscribe(result => {
        this.mobile = !result.matches;
        if(this.mobile){
          this.modalService.dismissAll();
        }
      });
  }
}
